module.exports = __webpack_public_path__ + "img/miss.43f29a91.svg";